/**
 * Timeline Event Handlers Composable
 * Handles pagination and reinitialize events for the timeline
 */

import type { Ref } from 'vue';
import type { PaginatedData } from '../utils/types';

interface TimelineInstance {
    reinitializeTimeline: (
        paginatedData: PaginatedData | null,
        groupBy: string,
        columnDisplay: { userId?: boolean; email?: boolean }
    ) => void;
}

interface Pagination {
    onPageSizeChange: (newSize: number) => void;
    goToFirstPage: () => void;
}

interface TimelineData {
    paginatedData: Ref<PaginatedData | null>;
}

interface Props {
    groupBy: string;
    columnDisplay: { userId?: boolean; email?: boolean };
}

export const useTimelineEventHandlers = (
    timelineInstance: TimelineInstance,
    pagination: Pagination,
    timelineData: TimelineData,
    props: Props
) => {
    const onPageSizeChange = (newSize: number) => {
        pagination.onPageSizeChange(newSize);
        timelineInstance.reinitializeTimeline(
            timelineData.paginatedData.value,
            props.groupBy,
            props.columnDisplay
        );
    };

    const onFirstPage = () => {
        pagination.goToFirstPage();
        timelineInstance.reinitializeTimeline(
            timelineData.paginatedData.value,
            props.groupBy,
            props.columnDisplay
        );
    };

    return {
        onPageSizeChange,
        onFirstPage
    };
};
